"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChecklistFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const checklist_1 = require("../../type-checking/checklist");
const get_value_1 = require("./get-value");
class ChecklistFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, checklist_1.isChecklistFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => {
            return (0, get_value_1.getEmptyChecklistValue)();
        };
    }
}
exports.ChecklistFieldValueGetter = ChecklistFieldValueGetter;
